/* Pin High: product card colour swatches. Desktop hover / mobile tap swaps the card image and link. */
(function () {
  if (window.__phCardSwatches) return;
  window.__phCardSwatches = true;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var LINKS = 'a.full-unstyled-link, a.phcs-card';
  function cardOf(el) { return el.closest('.card-wrapper, .phcs-card-wrap'); }
  function variantUrl(base, id) {
    try { var u = new URL(base, window.location.origin); u.searchParams.set('variant', id); return u.pathname + u.search + u.hash; }
    catch (e) { return base; }
  }
  function apply(btn) {
    var card = cardOf(btn);
    if (!card || btn.classList.contains('is-active')) return;
    var img = card.querySelector('.card__media img, .phcs-card__media img.phcs-img1, .phcs-card__media img');
    if (img && btn.dataset.src) {
      img.removeAttribute('loading');
      if (btn.dataset.srcset) img.setAttribute('srcset', btn.dataset.srcset);
      img.setAttribute('src', btn.dataset.src);
    }
    card.classList.add('ph-sw-active');
    card.querySelectorAll(LINKS).forEach(function (a) {
      if (!a.dataset.phBaseHref) a.dataset.phBaseHref = a.getAttribute('href');
      a.setAttribute('href', variantUrl(a.dataset.phBaseHref, btn.dataset.variantId));
    });
    card.querySelectorAll('.ph-card-swatch').forEach(function (b) {
      var on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function swatchFrom(e) { return e.target && e.target.closest ? e.target.closest('.ph-card-swatch') : null; }
  document.addEventListener('mouseover', function (e) { if (!canHover.matches) return; var b = swatchFrom(e); if (b) apply(b); });
  document.addEventListener('focusin', function (e) { var b = swatchFrom(e); if (b) apply(b); });
  document.addEventListener('click', function (e) {
    var b = swatchFrom(e);
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    apply(b);
    if (canHover.matches) {
      var card = cardOf(b), a = card && card.querySelector(LINKS);
      if (a) window.location.href = a.href;
    }
  }, true);
})();
